import { TFasterPayoutStatus } from '../../../../../api/src';
type TranslateFasterPayoutStatus = (
  key:
    | 'status.Created'
    | 'status.Ready'
    | 'status.Success'
    | 'status.Rejected'
    | 'status.Pending',
  options: { ns: 'fasterPayouts' },
) => string;

export const getFasterPayoutStatusLabel = (
  status: TFasterPayoutStatus,
  t: TranslateFasterPayoutStatus,
): string => {
  const ns = { ns: 'fasterPayouts' as const };
  switch (status) {
    case 'Created':
      return t('status.Created', ns);
    case 'Ready':
      return t('status.Ready', ns);
    case 'Success':
      return t('status.Success', ns);
    case 'Rejected':
      return t('status.Rejected', ns);
    case 'Pending':
      return t('status.Pending', ns);
    default:
      return status;
  }
};
